









































import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import QIconSelect from '@/components/QIconSelect.vue';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { LANGUAGE_MENU } from '@/constants/language-menu.constant';

@Component({
  components: {
    QIconSelect,
  },
})
export default class BankModal extends Mixins(ModalMixin) {
  form!: CrsForm<'definitions', 'createPackageFeature' | 'updatePackageFeature'>;

  get availableLanguages() {
    return LANGUAGE_MENU.map((item) => {
      return {
        label: item.name,
        code: item.iso,
        flag: item.img,
      };
    });
  }

  @Watch('mode', { immediate: true })
  switchForm(mode: 'create' | 'update') {
    const currentMode = mode === 'create' ? 'createPackageFeature' : 'updatePackageFeature';

    this.form = this.$crsForm('definitions', currentMode, {
      isActive: false,
      name: {},
      code: '',
      description: '',
    } as any);
  }

  async getForm() {
    return compass.do('definitions', 'findOnePackageFeature', {
      params: { id: this.id },
      lang: 'all',
    });
  }
}
